import { CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import CostBreakdown, { CostBreakdownProps } from '@/components/CostBreakdown/CostBreakdown';
import { SectionHeader } from './SectionHeader';

/** Order details' cost card: the same breakdown the create summary shows. */
export function CostSummarySection(props: CostBreakdownProps) {
  const { t } = useTranslation();

  return (
    <div className='rounded-2xl border border-sd-border bg-sd-card p-5'>
      <SectionHeader icon={CreditCard} title={String(t('cost_summary'))} />
      <CostBreakdown {...props} />
    </div>
  );
}
